import ExtLink from './ext-link.svg';
import Notice from './notice.svg';

export default {
  ExtLink,
  Notice,
};
